import { Set } from '~commonInfra/utils/Set';
import { Messages } from '~src/codegen/Localize';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { L10n } from '~src/commonInfra/L10n/L10n';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { openDeleteGroupSetConfirmationDialog } from '../../components/DeleteGroupSetConfirmationDialog';
import { GroupSets } from '../../GroupSets';
import { IGroupSetGroupInfo } from '../../models/IGroupSetInfo';
import { RemoveGroupsFromGroupSetNotificationAction } from '../notifications/RemoveGroupsFromGroupSetNotificationAction';


function showRemoveGroupsFromGroupSetDialog(groups: Set<IGroupSetGroupInfo>): Promise<any> {
    let dialogBody: string;

    if (groups.size() === 1) {
        const group = groups.first();
        dialogBody = Messages.confirmRemoveGroupFromGroupSet({ GROUP_NAME: L10n.elideIfLong(group.name) });
    } else {
        dialogBody = Messages.confirmRemoveGroupsFromGroupSet({ GROUP_COUNT_LOC: L10n.localizedCount(groups.size()) });
    }

    const dialogInstance = openDeleteGroupSetConfirmationDialog<IGroupSetGroupInfo[], IResult>({
        title: groups.size() === 1 ? Messages.removeGroupFromGroupSetMessage(): Messages.removeMultipleGroupsFromGroupSetMessage(),
        message: dialogBody,
        actionName: Messages.confirmRemoveButton({ ITEM_COUNT: groups.size() , ITEM_COUNT_LOC: L10n.localizedCount(groups.size()) }),
        isActionDelete: true,
        action: GroupSets.removeGroupsFromGroupSet.bind(groups),
        paramsForAction: groups.toArray(),
        dialogWidth: TabDialogWidth.width375px,
    });

    dialogInstance.result.then((result: IResult) => {
        RemoveGroupsFromGroupSetNotificationAction.notify(result, groups);
    });

    return Promise.resolve(dialogInstance.result);
}

export const RemoveGroupsFromGroupSetAction = {
    showRemoveGroupsFromGroupSetDialog
};

export type RemoveGroupsFromGroupSetAction = typeof RemoveGroupsFromGroupSetAction;